"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaErrorCodeConstants = void 0;
exports.isMediaStream = isMediaStream;
exports.isVideoElement = isVideoElement;
function isMediaStream(value) {
    if (typeof value !== "object" || value == null) {
        return false;
    }
    return "getAudioTracks" in value && "getVideoTracks" in value;
}
var MediaErrorCodeConstants;
(function (MediaErrorCodeConstants) {
    MediaErrorCodeConstants[MediaErrorCodeConstants["UNKNOWN"] = 0] = "UNKNOWN";
    MediaErrorCodeConstants[MediaErrorCodeConstants["MEDIA_ERR_ABORTED"] = 1] = "MEDIA_ERR_ABORTED";
    MediaErrorCodeConstants[MediaErrorCodeConstants["MEDIA_ERR_NETWORK"] = 2] = "MEDIA_ERR_NETWORK";
    MediaErrorCodeConstants[MediaErrorCodeConstants["MEDIA_ERR_DECODE"] = 3] = "MEDIA_ERR_DECODE";
    MediaErrorCodeConstants[MediaErrorCodeConstants["MEDIA_ERR_SRC_NOT_SUPPORTED"] = 4] = "MEDIA_ERR_SRC_NOT_SUPPORTED";
    MediaErrorCodeConstants[MediaErrorCodeConstants["MEDIA_ERR_ENCRYPTED"] = 5] = "MEDIA_ERR_ENCRYPTED";
})(MediaErrorCodeConstants || (exports.MediaErrorCodeConstants = MediaErrorCodeConstants = {}));
function isVideoElement(el) {
    return (el === null || el === void 0 ? void 0 : el.src) !== undefined;
}
//
// export interface VideoDriver {
//   /**
//    * Initializes the video driver. This method is called once when the video driver is created.
//    * It loads all 3rd party libraries and other resources that are required for the video driver.
//    */
//   init(): Promise<void>;
//
//   /**
//    * Prepares the video driver for playback. Loads metadata and other information about the video.
//    * Joining a live stream is also done in this method.
//    */
//   loadMedia(manifest: ManifestJson): void;
//
//   /**
//    * Updates the video driver with new media information. This method is called when the video
//    * driver is already loaded and the media information changes.
//    */
//   updateMedia(manifest: ManifestJson): void;
//
//   /**
//    * Tries to change the quality of the video if possible.
//    * Returns a promise that resolves to the new quality level.
//    */
//   tryUpdateQuality(level: PreferredLevel): Promise<PreferredLevel>;
//
//   /**
//    * Returns the current quality level of the video.
//    */
//   getCurrentQuality(): Promise<PreferredLevel>;
// }
//# sourceMappingURL=video-element.js.map